import {mapGetters} from "vuex";

export default {
  data() {
    return {
      authLoading: false,
      availableAuthMethods: undefined,
      alternativeAuthMethods: undefined, // all available methods except itriglav & nadaljuj brez prijave

      isAuth: false,
      authData: {},
      labelsByAuthMethod: {
        3: 'Prijava z davčno in ZZZS številko',
        4: 'Prijava z davčno številko in datumom rojstva',
        6: 'Identifikacija s SMS kodo',
        9: 'Nadaljuj brez prijave'
      },
      authContactPreAuth: undefined
    }
  },

  computed: {
    ...mapGetters(['queryObject'])
  },

  // Checks the auth status of the user and redirects appropriately
  async created() {
    await this.init();
  },
  methods: {
    async init() {
      this.showLoadingBig();

      this.authLoading = true;

      await this.fetchAvailableAuthMethods();
      await this.initAuth();

      this.authLoading = false;

      if (this.$route.name === 'POBR') {
        this.initPOBR();
      }

      this.hideLoading();
    },

    async fetchAvailableAuthMethods() {
      try {
        if (this.$route.name === 'POBR-Auth') {
          await this.$http.post('/auth/check-params-prerequisites', this.queryObject);
        }

        const fetchAvailableAuthMethods = await this.$http.post('/auth/methods', this.queryObject);
        this.availableAuthMethods = fetchAvailableAuthMethods.data;
        this.alternativeAuthMethods = this.availableAuthMethods.filter(am => ![2, 9].includes(am));

        if (this.alternativeAuthMethods.includes(6)) {
          await this.getAuthContactPreAuthInfo();
        }
      } catch (e) {
        this.navigateToNotFound();
        return await this.handleError(e, this.fetchAvailableAuthMethods.bind(this));
      }
    },
    async initAuth() {
      const authData = await this.checkAuth();

      if (authData) {
        this.authData = authData;
        this.isAuth = true;

        if (this.queryObject.id) {
          if (this.queryObject.id === this.authData.id) {
            this.$store.dispatch('setAuthData', authData);

            if (this.$route.name === 'POBR-Auth') {
              const moveQuery = {};

              if (this.queryObject.wv) {
                moveQuery.x = 'wv=true'
              }

              await this.$router.push({
                name: 'POBR',
                params: {
                  id: this.authData.id
                },
                query: moveQuery
              });
            }
          } else {
            this.deauth();
          }
        } else {
          this.deauth();
        }
      } else {
        if (await this.checkIDotTriglavAuth() === false) {
          if (this.$route.name === 'POBR') {
            if (this.queryObject.id) {
              return await this.$router.replace({
                name: 'POBR-Auth',
                query: {x: `id=${this.queryObject.id}${this.queryObject.wv ? '|wv=true' : ''}`}
              });
            } else {
              this.navigateToNotFound();
            }
          }
        }
      }
    },
    async checkAuth() {
      try {
        const checkAuthResponse = await this.$http.get(`auth`);
        return checkAuthResponse.data;
      } catch {
        return false;
      }
    },
    async checkIDotTriglavAuth() {
      try {
        if (this.availableAuthMethods.includes(2)) {
          const loggedInUserAttempt = await this.checkIDotTriglavAuthLoggedInUser();

          if (loggedInUserAttempt === false) {
            const ssoTokenAttempt = await this.checkIDotTriglavAuthSSO();

            if (ssoTokenAttempt === false) {
              const accessTokenAttempt = await this.checkIDotTriglavAuthAccessToken();

              if (accessTokenAttempt === false) {
                return false;
              }
            }
          }
        } else {
          return false;
        }
      } catch (e) {
        return await this.handleError(e, this.checkIDotTriglavAuth.bind(this));
      }
    },
    async checkIDotTriglavAuthLoggedInUser() {
      try {
        const loggedInUserResponse = await this.$http.get(`https://${process.env.VUE_APP_ITRIGLAV_ROOT_URL}/TriglavLogin/logged-in-user`, {
          withCredentials: true
        });

        if (loggedInUserResponse.status === 200 && loggedInUserResponse.data !== "") {

          if (loggedInUserResponse.data.oid) {

            const authITriglavLoggedInUserResponse = await this.$http.post('auth/i-triglav/logged-in-user', {
              id: this.queryObject.id,
              oid: loggedInUserResponse.data.oid,
              pid: this.queryObject.pid,
              tid: this.queryObject.tid,
              ep: this.queryObject.ep
            });

            if (authITriglavLoggedInUserResponse.status === 200) {
              this.onAuthSuccessful(authITriglavLoggedInUserResponse.data);
            }
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    },
    async checkIDotTriglavAuthSSO() {
      try {
        if (this.$route.query.ssoCookieTokenValue) {
          const token = this.$route.query.ssoCookieTokenValue;
          this.$router.replace({query: {ssoCookieTokenValue: undefined, x: this.$route.query.x}});

          const checkIDotTriglavAuthSSOResponse = await this.$http.post('auth/i-triglav/sso', {
            id: this.queryObject.id,
            sso: token,
            pid: this.queryObject.pid,
            tid: this.queryObject.tid,
            ep: this.queryObject.ep
          });

          if (checkIDotTriglavAuthSSOResponse.status === 200) {
            this.onAuthSuccessful(checkIDotTriglavAuthSSOResponse.data);
          }
        } else {
          return false;
        }
      } catch (e) {
        return await this.handleError(e, this.checkIDotTriglavAuthSSO.bind(this));
      }
    },
    async checkIDotTriglavAuthAccessToken() {
      try {
        if (this.queryObject.accessToken === 'JWT_TOKEN' && this.queryObject.accesstoken) {
          const checkIDotTriglavAccessTokenResponse = await this.$http.post('auth/i-triglav/access-token', {
            id: this.queryObject.id,
            at: this.queryObject.accesstoken,
            pid: this.queryObject.pid,
            tid: this.queryObject.tid,
            ep: this.queryObject.ep
          });

          if (checkIDotTriglavAccessTokenResponse.status === 200) {
            this.onAuthSuccessful(checkIDotTriglavAccessTokenResponse.data);
          }
        } else {
          return false;
        }
      } catch (e) {
        return await this.handleError(e, this.checkIDotTriglavAuthAccessToken.bind(this));
      }
    },
    deauth() {
      window.localStorage.removeItem('pobr-auth');
      this.init();
    },
    onITriglavLogout() {
      this.$store.dispatch('iTriglavLogout');
    },
    async attemptAlternativeAuth(id, tid, ep, pid, vat, kzz, birthDate, otp) {
      try {
        this.showLoadingBig();

        const attemptAlternativeAuthResponse = await this.$http.post('/auth', {
          id, tid, ep, pid, vat, kzz, birthDate, otp
        });

        if (attemptAlternativeAuthResponse.status === 200) {
          await this.onAuthSuccessful(attemptAlternativeAuthResponse.data);
        }

        this.hideLoading();
      } catch (e) {
        this.hideLoading();

        if (e.response && e.response.status === 401 && e.response.data && e.response.data.remainingAttempts) {
          this.notifyCustomError('Vnesena koda ni pravilna. Preostalih poskusov: ' + e.response.data.remainingAttempts);
        } else {
          return await this.handleError(e, this.attemptAlternativeAuth.bind(this, ...arguments));
        }
      }
    },
    async onAuthSuccessful(authResponse) {
      window.localStorage.setItem('pobr-auth', authResponse.token);

      if (!this.queryObject.id) {
        await this.$router.replace({
          name: 'POBR-Auth',
          query: {
            x: `id=${authResponse.id}${this.queryObject.wv ? '|wv=true' : ''}`
          }
        });
      }

      this.buildQueryObject();
      await this.init();
    },
    async getAuthContactPreAuthInfo() {
      if (this.queryObject.id) {
        try {
          const getAuthContactPreAuthInfoResponse = await this.$http.get(`/auth/contact/pre-auth-info/${this.queryObject.id}`);
          this.authContactPreAuth = getAuthContactPreAuthInfoResponse.data.contact;

        } catch (e) {
          return await this.handleError(e, this.getAuthContactPreAuthInfo.bind(this));
        }
      }
    },
    async initiateAuthClientViaPOBRAuthContact() {
      if (this.queryObject.id) {
        try {

          await this.showLoadingBig();

          await this.$http.post('/auth/contact', {
            id: this.queryObject.id
          });

          this.hideLoading();
        } catch (e) {
          return await this.handleError(e, this.initiateAuthClientViaPOBRAuthContact.bind(this));
        }
      }
    }
  }
}
